<template>
    <div class="header">
        <div class="navigation">
            <div class="navigation__left navigation__left--icons">
                <img @click="go('home')"
                    class="navigation__desktop-logo"
                    src="@/assets/images/logos/freddies_flowers_stacked.svg"
                    alt="Freddie's Flowers Desktop Logo"/>

                <div class="navigation__dashboard-home" v-if="isUserLoggedIn" @click="go('home')">
                    <img src="@/assets/images/user-menu/dashboard.png"/>
                    <h4>{{ $t('NAV_HOME_ICON') }}</h4>
                </div>
                <div v-if="!isPage(['register', 'account', 'login'])" class="navigation__landing-buttons">
                    <div :key="index" v-for="(button, index) in filteredButtons" @click="go(button.route)">
                        <nav-button :button="button" :key="index" class="navigation__landing-button"/>
                    </div>
                </div>
                <help-button v-if="!isUserLoggedIn || (isUserLoggedIn && hasActiveSubscription)" class="navigation__help"></help-button>
            </div>

            <div class="navigation__center">
                <!-- Small logo -->
                <router-link v-if="showHomePageTitle" :to="{ name: 'home'}" class="navigation__mobile-logo-container">
                        <img class="navigation__mobile-logo" src="@/assets/images/logos/freddies_flowers_logo_horizontal.svg" alt="Freddie's Flowers Mobile logo"/>
                </router-link>

                <div v-else v-html="navigationTitle" class="navigation__title"></div>
            </div>

            <div class="navigation__right">
                <language-switcher class="hidden lg:block"></language-switcher>
                <order-summary-button v-if="isUserLoggedIn && showOrderSummary"/>
                <!-- <div class="country--switcher">
                    <country-switch-dropdown />
                </div> -->
                <login-link v-if="!onCardDetailsPage"></login-link>
                <help-button class="hidden lg:block" v-if="!isUserLoggedIn"/>
            </div>
        </div>
        <div class="divider-paper--top divider--not-fixed"></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import LoginLink from '@/components/structure/navigation/navigation/LogInLink';
import HelpButton from '@/components/structure/navigation/navigation/HelpButton';
import NavButton from '@/components/structure/navigation/navigation/NavButton';
import LanguageSwitcher from '@/components/structure/navigation/navigation/LanguageSwitcher';
import OrderSummaryButton from '@/components/structure/navigation/navigation/OrderSummaryButton';
// import CountrySwitchDropdown from '@/components/structure/navigation/CountrySwitchDropdown';

export default {
    name: 'TopNavigation',
    computed: {
        ...mapGetters({
            buttons: 'nav/getButtons',
            isUserLoggedIn: 'auth/isUserLoggedIn',
            isUSA: 'localisation/isUSA',
            hasActiveSubscription: 'subscription/getActiveSubscriptionId',
        }),
        filteredButtons() {
            const status = (this.isUserLoggedIn ? 'loggedIn' : 'loggedOut');
            return this.buttons.filter(button => button[status]);
        },
        logoRedirectRoute() {
            return this.isUserLoggedIn ? 'account.dashboard' : 'home';
        },
        onCardDetailsPage() {
            return this.$route.name === 'register.card-details';
        },
        showHomeButton() {
            return this.isUserLoggedIn && !this.onCardDetailsPage;
        },
        navigationTitle() {
            const navigation = this.$store.state.route.meta.navigation;
            if (navigation === undefined) {
                return null;
            }
            return this.$t(navigation.titleTranslateKey);
        },
        showHomePageTitle() {
            return this.navigationTitle === null;
        },
        showOrderSummary() {
            const route = this.$route.name;
            return route.includes('account.shop');
        },
    },
    methods: {
        isPage(pageArr) {
            const pageRoot = this.$route.name.split('.')[0];
            return pageArr.find(page => pageRoot === page);
        },
        go(route) {
            this.$router.push({ name: route });
        },
    },
    components: {
        LoginLink,
        HelpButton,
        LanguageSwitcher,
        OrderSummaryButton,
        NavButton,
        // CountrySwitchDropdown,
    },
};
</script>

<style lang="scss" >
    .header {
        position: fixed;
        width: 100vw;
        z-index: 99;
    }
    .navigation {
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding: 0 16px;
        background: center;
        background-repeat: repeat-x;
        height: 70px;
        background-position: center;
        z-index: 99;
        background-image: url('../../../assets/images/decoration/bg–paper.jpg');
        &__desktop-logo {
            display: none;
        }
        &__dashboard-home {
            cursor: pointer;
            margin: 16px 0 0 16px;
            display: none;
            img {
                height: 24px;
                width: 24px;
                margin: 0 auto;
            }
        }

        @media (max-width: 1024px) {
            .country--switcher {
                display: none;
            }
            &__landing-buttons {
                position: fixed;
                bottom: 90px;
                left: 0px;
                display: inline-flex;
                justify-content: center;
                width: 100%;
                gap: 80px;
                background: white;
                padding: 10px;
                z-index: 1;
            }
        }
        &__landing-button {
            cursor: pointer;
            text-align: center;
            text-transform: uppercase;
            img {
                margin: 0 auto;
                height: 45px;
            }
            h5 {
                font-size: 10px;
                margin: 0;
            }
        }
        &__left {
            width: 4rem;
            padding: 16px 16px 0;
            align-items: center;
            margin-right: 16px;
            display: flex;
            justify-content: left;
        }
        &__help {
            display: block;
        }
        &__center {
            text-align: center;
            padding-bottom: 8px;
            display: flex;
            justify-content: center;
            width: 470px;
        }
        &__mobile-logo-container {
            width: 100%;
        }
        &__mobile-logo {
            display: block;
            width: 100%;
            max-width: 380px;
        }
        &__title {
            font-size: 1.25rem;
            line-height: 1;
            font-family: FreddiesFlowersTitle;
            padding-top: 4px;
        }
        &__title > span {
            font-size: 0.5em;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
            display: block;
            text-transform: uppercase;
        }
        &__right {
            display: flex;
            justify-content: flex-end;
            min-width: 80px;
        }
        &__center, &__right {
            padding: 16px 16px 0;
            align-items: center
        }
    }
    @media (min-width: 300px) {
        .navigation {
            &__center {
                justify-content: space-between;
            }
        }
    }
    @media (min-width: 768px) {
        .navigation {
            padding: 16px;
            &__left {
                padding-bottom: 8px;
                width: 198px;
            }
            &__center {
                justify-content: center;
            }
            &__right {
                min-width: 198px;
            }
            &__landing-buttons {
                display: none;
            }
        }
    }
    @media (min-width: 1024px) {
        .country--switcher {
            display: auto;
        }
        .navigation {
            height: 94px;
            &__desktop-logo {
                display: block;
                width: 120px;
            }
            &__landing-buttons {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                width: 200px;
                height: 40px;
                margin-left: 40px;
            }
            &__landing-button {
                margin-right: 40px;
            }
            &__dashboard-home {
                display: block;
            }
            &__help {
                display: none;
            }
            &__center {
                flex: 1 1 0%;
                align-content: flex-start;
                padding-bottom: 0;
                justify-content: center;
            }
            &__mobile-logo-container {
                width: auto;
            }
            &__mobile-logo {
                display: none;
            }
            &__left {
                padding-bottom: 8px;
                &--icons {
                    width: auto;
                }
            }
            &__right {
                padding-bottom: 0;
                > * {
                    margin: 0 16px;
                }
            }
        }
    }
</style>
